import { render, staticRenderFns } from "./EduCation.vue?vue&type=template&id=a367f872&"
import script from "./EduCation.vue?vue&type=script&lang=js&"
export * from "./EduCation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports